import { gql } from '@apollo/client';

export const QUERYV2 = gql`
  mutation UpdateSubscriptionV2ByToken($payload: AutoFilledUpdateSubscriptionPayload!, $token: String!) {
    updateSubscriptionV2ByToken(payload: $payload, token: $token) {
      nextAction
      subscription {
        startDate
        endDate
        cancelDate
        frequency
        status
        amountDue
        lastPaymentDate
        _id
        updatedAt
        createdAt
        nextBillingDate
        product {
          name
        }
        pricing {
          name
        }
      }
    }
  }
`;
